<oui-icon class="icon">{{ icon() }}</oui-icon>
